import React from 'react';
import { Button } from './Button';
export function FinalCTA() {
  return <section className="py-20 bg-white text-center" data-id="element-62">
      <div className="container mx-auto px-4 md:px-6" data-id="element-63">
        <div className="max-w-3xl mx-auto" data-id="element-64">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-65">
            Empezá hoy a construir tu tranquilidad financiera
          </h2>
          <p className="text-lg text-stone-600 mb-10" data-id="element-66">
            No dejes pasar otro mes sin saber a dónde va tu dinero. Ordená tus
            números, eliminá el estrés y tomá el control.
          </p>
          <Button href="https://checkout.tuvidasimple.shop/products/plantilla-de-finanzas-personales?variant=44058955939942" className="px-12" data-id="element-67">
            Empezar hoy por $19.990
          </Button>
        </div>
      </div>
    </section>;
}